import { makeArrayOfNumbers } from "../../helpers";

export default makeArrayOfNumbers(1980, new Date().getFullYear() + 10);
